import { useNavigate } from 'react-router-dom';
import { AdminLayout as BaseAdminLayout } from '@festpix/ui';
import { auth } from '@festpix/services';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  const navigate = useNavigate();
  const user = auth.currentUser;

  const handleSignOut = () => {
    auth.signOut();
    navigate('/login');
  };

  return (
    <BaseAdminLayout
      userEmail={user?.email || undefined}
      onSignOut={handleSignOut}
      logoSrc="/logo.png"
      basePath="/admin"
    >
      {children}
    </BaseAdminLayout>
  );
}
